export default __webpack_public_path__ + "static/media/15.ca82196e.jpg";